<script setup lang="ts">
defineProps<{
  title?: string;
  showTitle?: boolean;
  shouldShow?: boolean;
  customClass?: string;
}>();
</script>
<template>
  <section :class="['tw-my-4', customClass]" v-if="shouldShow">
    <h5 v-if="showTitle && title" class="Field__label tw-text-base">
      {{ title }}
    </h5>
    <slot />
  </section>
</template>
